<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h2 class="mb-0">{{all_customers.length}}</h2>
            <p>All Customers</p>
          </b-card-body>
          <card-line1-chart-example chartId="card-chart-01" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h2 class="mb-0">{{pending_loans}}</h2>
            <p>Pending Loans</p>
          </b-card-body>
          <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h2 class="mb-0">{{active_loans}}</h2>
            <p>Active Loans</p>
          </b-card-body>
          <card-line3-chart-example chartId="card-chart-03" class="chart-wrapper" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h2 class="mb-0">₦0.00</h2>
            <p>Monthly Disbursed Amount</p>
          </b-card-body>
          <card-bar-chart-example chartId="card-chart-04" class="chart-wrapper px-3" style="height:70px;" height="70"/>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-card header="Recent Customers">
          <p v-if="loading" style="text-align: center;padding: 20px">
            <span style="font-size: 25px;">
              <i class="fa fa-spinner fa-spin"></i> Loading...
            </span>
          </p>
          <div v-else>
            <div v-if="tableData.length < 1">
              <p style="font-size: 15px;" class="text-center">
                <i>There are no news customers at this moment.</i>
              </p>
            </div>
            <div v-else>
              <v-client-table :data="tableData" :columns="columns" :options="options">
                <b-link slot="actions" slot-scope="props" to="#" @click="viewUser(props.row.actions)"><i class="fa fa-eye"> </i> View Profile</b-link>
              </v-client-table>
            </div>
          </div>
          <div class="row">
              <div class="col-md-6 col-sm-12 col-xs-12">
                  <div class="pagination">
                      <span @click="getPaginated(1)">&laquo;</span>
                          <strong v-for="(number,index) in pageNumbers" :key="index" @click="getPaginated(number)">
                              <span v-if="number === 1 || number === total_pages || (number >= current_page - 2 && number <= current_page + 2)">{{number}}</span>
                          </strong>
                      <span @click="getPaginated(last_page)">&raquo;</span>
                  </div>
              </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue';
import { allUsers } from '@/services/userService';
import { getLoanByStatus } from '@/services/loanService';
import IdleModal from '@/components/IdleModal';

export default {
  name: 'dashboard',
  components: {
    Callout,
    IdleModal
  },
  data: function () {
    return {
      selected: 'Month',
      columns: ['first_name', 'last_name', 'gender', 'date', 'actions'],
      tableData: [],
      per_page: 20,
      last_page: 0,
      total_pages: 0,
      current_page: 0,
      pageNumbers: [],
      loading: false,
      all_customers: [],
      pending_loans: [],
      active_loans: [],
      options: {
        headings: {
          first_name: 'First Name',
          last_name: 'Last Name',
          gender: 'Gender',
          date: 'Reg Date',
          actions: 'View Details'
        },
        sortable: ['first_name', 'last_name'],
        filterable: ['first_name', 'last_name', 'gender']
      }
    }
  },
  created () {
    this.fetchCustomers(1);
    this.setActiveLoans();
    this.setPendingLoans();
  },
  methods: {
    fetchCustomers(page_number) {
      this.loading = true;
      allUsers(page_number).then(({data:{datas}}) => {
        this.tableData = [];
        const filtered = datas.data.filter(customers => customers.roles[0].name === "customer");
        const customers = filtered.map(customer => customer.customer);
        this.all_customers = customers;
        const users = customers;
        this.loading = false;
        this.setData(datas);

        for(let i=0;i<=9;i++) {
          this.tableData.push({
            id: i,
            first_name: users[i].first_name,
            last_name: users[i].last_name,
            gender: users[i].gender,
            date: users[i].created_at,
            actions: users[i].id
          });
        }
      })
      .catch(error => {
          this.loading = false;
      });
    },
    async setPendingLoans() {
      const {data} = await getLoanByStatus(1);
      this.pending_loans = data.loans.length;
    },
    async setActiveLoans() {
      const {data} = await getLoanByStatus(5);
      this.active_loans = data.loans.length;
    },
    getPaginated(page_number) {
      this.fetchCustomers(page_number);
    },
    setData(data) {
      let total_pages, last_page, current_page;
      let page_numbers = [];

      if(data) {
          total_pages = data.total;
          last_page = data.last_page;
          current_page = data.current_page;
      }
      else {
          total_pages = 0;
          last_page = 0;
          current_page = 0;
      }
      
      for (let i = 1; i <= Math.ceil(total_pages / data.per_page); i++) {
          page_numbers.push(i);
      }

      this.current_page = current_page;
      this.total_pages = total_pages;
      this.last_page = last_page;
      this.pageNumbers = page_numbers;
    },
    viewUser(id) {
      this.$router.push(`/customers/${id}`);
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    }
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  .pagination {
      margin-top: 25px;
  }

  .pagination span {
      cursor: pointer;
      color: black;
      float: left;
      padding: 8px 16px;
      text-decoration: none;
      transition: background-color .3s;
      border: 1px solid #ddd;
  }

  .pagination span.active {
      background-color: #15974b;
      color: white;
      border: 1px solid #15974b;
  }
</style>